<ppl-dialog title="Space Access Forbidden"
            i18n-title="@@SpaceAccessForbidden"
            [actionVisible]="false"
            cancelLabel="close">
  <ppl-space-access-forbidden [space]="space"></ppl-space-access-forbidden>
</ppl-dialog>